import clsx from "clsx";
// import { Button } from "@mui/material";
// import { VscLaw } from "react-icons/vsc";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useMemo, useState } from "react";
import { GiWallet } from "react-icons/gi";

import { Logo } from "../Logo";
import { isMobile } from "../../utils";
// import { getIconSVG } from "../../constants";
// import { UserPlanEnum } from "../../constants/plans";
import { useAuth } from "../../contexts/AuthContext";
import { PoweredByVelotax } from "../PoweredByVelotax";
import { useBroker } from "../../contexts/BrokerContext";
import { useSideBar } from "../../contexts/SideBarContext";
import { useTransferenciaCustodia } from "../../contexts/TransferenciaCustodiaContext";
// import { ReactComponent as ConfiguracoesIcon } from "../../assets/icons/configuracoes.svg";
import {
  // ContentButton,
  DrawerSider,
  LayoutSider,
  Module,
  Modules,
  ModuleSubMenu,
  SupportContainerIcon,
  // Settings,
} from "./styles";
import { useOldTransactions } from "../../pages/Darf/Components/OldTransactions/hook";
import { QuestionCircleOutlined } from "@ant-design/icons";

interface ISideBarProps {
  pagePath: string;
}

interface ISideBarContainerProps {
  visible: boolean;
  setVisible: Function;
}

const SideBarContainer: React.FC<ISideBarContainerProps> = ({
  children,
  visible,
  setVisible,
}) =>
  isMobile() ? (
    <DrawerSider
      title=""
      width="256px"
      footer={null}
      closeIcon={null}
      placement="left"
      visible={visible}
      onClose={() => setVisible(false)}
    >
      {children}
    </DrawerSider>
  ) : (
    <LayoutSider theme="light" width="256px">
      {children}
    </LayoutSider>
  );

const Sidebar: React.FC<ISideBarProps> = ({ pagePath }) => {
  const navigate = useNavigate();
  // const { user, showUserPlanModal } = useAuth();
  const { user } = useAuth();
  const { showDrawer, setShowDrawer, dark } = useSideBar();
  const { currentBrokerAbledPages, currentBroker } = useBroker();
  const { oldPositionList } = useOldTransactions();
  const { ativos: ativosCustodia } = useTransferenciaCustodia();

  const [openKeys, setOpenKeys] = useState([""]);
  const [init, setInit] = useState(false);

  // const label = useMemo(() => {
  //   if (
  //     !user?.user?.userPlanInfoVelotax?.type ||
  //     !user?.user?.userPlanInfoVelotax?.active
  //   )
  //     return "Atualizar Plano";

  //   if (user?.user?.userPlanInfoVelotax?.type === "VELOTAX_MAIN_BASIC")
  //     return "Plano Basic";
  //   if (
  //     user?.user?.userPlanInfoVelotax?.type === UserPlanEnum.MYNT_PRO ||
  //     user?.user?.userPlanInfoVelotax?.type === UserPlanEnum.MYNT_PRO_MONTH
  //   )
  //     return "Plano Premium";
  // }, [user?.user?.userPlanInfoVelotax]);

  const pages = useMemo(
    () =>
      currentBrokerAbledPages.filter(
        (page) =>
          !page.hideOnSideBar && page.subPages && page.subPages.length > 0
      ),
    [currentBrokerAbledPages]
  );

  const sidebarPages = useMemo(() => {

    return currentBrokerAbledPages
      ?.filter((page) => !page.hideOnSideBar)
      .filter(
        (page) =>
          ativosCustodia.length === 0 ? page.path !== "mynt/transferencia-custodia" : page
      )
      .map((page) =>
        (oldPositionList?.length < 1 || oldPositionList === null) &&
          page.calcId === "bolsa"
          ? {
            ...page,
            subPages: page.subPages?.filter(
              (subPage) =>
                subPage.path !== "bolsa-insert-manual"
            ),
          }
          : page
      )
  }, [currentBrokerAbledPages, oldPositionList, ativosCustodia.length]);

  const sidebarselectedcolor = dark
    ? currentBroker.colors.sidebarSelectedColorDark
    : currentBroker.colors.sidebarSelectedColor;

  const handleNavigate = (path: string) => {
    if (path.includes("http")) {
      window.open(path, "_blank")?.focus();
    } else {
      setShowDrawer(false);
      navigate(path);
    }
  };

  const onOpenChange = (keys: string[]) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (pages.map((page) => page.path).indexOf(latestOpenKey!) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  useEffect(() => {
    const openKey = pages.find((page) =>
      page.subPages?.some((subPage) => subPage.path === pagePath)
    )?.path;
    if (openKey) {
      setOpenKeys([openKey]);
    }
  }, [pagePath, pages]);

  const loginInSupport = async (cpf: string) => {
    try {
      const token = localStorage.getItem("@VeloTax:token");
      const urlSupportSSO = process.env.REACT_APP_SUPPORT_URL ? `${process.env.REACT_APP_SUPPORT_URL}p/sso/${token}` : `http://localhost:3000/p/sso/${token}`;
      window.open(
        urlSupportSSO,
        isMobile() ? "_self" : "_blank"
      );
    } catch (err) {
      console.log('erro ao tentar logar no suporte')
    }
  };

  useEffect(() => {
    if (ativosCustodia.some((item) => (!item.dataCompra || !item.value) && (!init))) {
      handleNavigate("mynt/transferencia-custodia");
      setInit(true);
    }
    // eslint-disable-next-line
  }, [ativosCustodia]);

  return (
    <SideBarContainer visible={showDrawer} setVisible={setShowDrawer}>
      <Logo />
      <Modules
        mode="inline"
        openKeys={openKeys}
        selectedKeys={[pagePath]}
        onOpenChange={onOpenChange}
        className={clsx("beauty-scrollbar zero-scrollbar", {
          user: !!user.user,
          poweredBy: !currentBroker.hidePoweredBy,
        })}
      >
        {/* <Module
          key="/"
          title="Início"
          icon={<RiHome6Line size={24} color="var(--ant-primary-color)" />}
          onClick={() => handleNavigate("/")}
          sidebarselectedcolor={sidebarselectedcolor}
        >
          Início
        </Module> */}
        {user.user ? (
          sidebarPages
            .map((page) =>
              page.subPages && page.subPages.length > 0 ? (
                <ModuleSubMenu
                  key={page.path}
                  icon={page.icon}
                  title={page.name}
                  sidebarselectedcolor={sidebarselectedcolor}
                >
                  {page.subPages?.map((subpage) => (
                    <Module
                      key={subpage.path}
                      icon={subpage.icon}
                      title={subpage.name}
                      onClick={() => handleNavigate(subpage.path)}
                      sidebarselectedcolor={sidebarselectedcolor}
                    >
                      {subpage.name}
                    </Module>
                  ))}
                </ModuleSubMenu>
              ) : (
                <Module
                  key={page.path}
                  icon={page.icon}
                  title={page.name}
                  onClick={() => handleNavigate(page.path)}
                  sidebarselectedcolor={sidebarselectedcolor}
                >
                  {page.name}
                </Module>
              )
            )
        ) : (
          <>
            <Module
              icon={<></>}
              key="/p/login"
              onClick={() => handleNavigate("/p/login")}
              sidebarselectedcolor={sidebarselectedcolor}
            >
              Login
            </Module>
            <Module
              icon={<></>}
              key="/p/cadastrar"
              onClick={() => handleNavigate("/p/cadastrar")}
              sidebarselectedcolor={sidebarselectedcolor}
            >
              Cadastro
            </Module>
          </>
        )}
          {isMobile() &&
                <Module
                    icon={
                      <SupportContainerIcon>
                        <QuestionCircleOutlined style={{ fontSize: '24px' }} />
                      </SupportContainerIcon>
                    }
                    title={'suporte'}
                    onClick={() => {
                      loginInSupport(user.user.cpf);
                    }}
                    sidebarselectedcolor={sidebarselectedcolor}
                  >
                  Suporte 
                </Module>}
        {currentBroker.useCarteira &&
          (currentBroker.hideCalculadoras ||
            user?.user?.visibleCalcs?.includes("carteira")) && (
            <Module
              key="/carteira"
              title="carteira"
              icon={<GiWallet size={24} color="var(--ant-primary-color)" />}
              onClick={() => handleNavigate("/carteira")}
              sidebarselectedcolor={sidebarselectedcolor}
            >
              Meus investimentos
            </Module>
          )}

      </Modules>
      {!currentBroker.hidePoweredBy && (
        <PoweredByVelotax className="poweredby-velotax sidebar" />
      )}
      {/* <ContentButton>
        <Button
          size="medium"
          color="secondary"
          variant="contained"
          onClick={() => {
            showUserPlanModal(true, "Planos");
            setShowDrawer(false);
          }}
        >
          {label}
        </Button>
      </ContentButton> */}
      {/* {user.user && (
        <Settings selectedKeys={[pagePath]}>
          {currentBroker.useSettings && (
            <Module
              key="Config"
              className="setting"
              sidebarselectedcolor={sidebarselectedcolor}
              onClick={() =>
                handleNavigate(`${currentBroker.path}/configuracoes`)
              }
              icon={getIconSVG(
                pagePath === `${currentBroker.path}/configuracoes`,
                ConfiguracoesIcon
              )}
            >
              Config.
            </Module>
          )}
        </Settings>
      )} */}
    </SideBarContainer>
  );
};

export default Sidebar;
